export enum MAIN_REPORT  {
  exportAdminHours = 'exportAdminHours',
  exportEmployeeHours = 'exportEmployeeHours',
  exportIncidents = 'exportIncidents',
  exportAdmin = 'exportAdmin',
  exportResponsible = 'exportResponsible',
  exportNotImputed = 'exportNotImputed',
  exportInterventionHoursControl = 'exportInterventionHoursControl',
  exportGuards = 'exportGuards',
  exportsDesvWorkingDay = 'exportsDesvWorkingDay',
  exportExtraHours = 'exportExtraHours',
  exportClient = 'exportClient',
  exportEmployee = 'exportEmployee',
  exportResponsibleHours = 'exportResponsibleHours',
  exportResponsibleOpenModal = 'exportResponsibleOpenModal',
  exportOpenModalClient = 'exportOpenModalClient',
  exportOpenModalEmployee = 'exportOpenModalEmployee',
  exportOpenModalDesvWorkingDay = 'exportOpenModalDesvWorkingDay',
  exportProjectFeesEmployee = 'exportProjectFeesEmployee'
}

export enum ROL_TYPE {
  employee = 1, // empleado
  advisory = 2, // consultivo
  admin = 3, // admin
  manager = 4, // gestor
  operations = 5, // operaciones
  direction = 6 // dirección
}
